import { useTranslation } from "react-i18next";
import CustomCheckbox from "../../../../custom-components/form-inputs/CustomCheckbox";
import CheckMarkIconSVG from "../../svg/CheckMarkIconSVG";
import { FormikProps } from "formik";
import { FormWithPhones, PhoneInfoForm } from "../../../../domain/models/dto/PhoneDTO";
import CustomError from "../../../../custom-components/form-inputs/CustomError";
import _ from "lodash";
import useScreenSize from "../../../../custom-hooks/base-hooks/useScreenSize";
import { Fields } from "../../../../types/SchemaFactory";
import PhoneInput from "../form-inputs/PhoneInput";

interface MobilePhoneInfoProps<T> {
    form: FormikProps<T>;
    fields: Fields<T>;
    value: PhoneInfoForm;
    index: number;
    viberCheckboxHandler: (index: number) => () => void;
    whatsappCheckboxHandler: (index: number) => () => void;
}

function MobilePhoneInfo<T extends FormWithPhones>(props: MobilePhoneInfoProps<T>) {
    const { upTo650, moreOrEqual650 } = useScreenSize();
    const { t } = useTranslation();

    return (
        <div className="relative w-full">
            {upTo650 && (
                <p className="H16B dmax2:H14B text-textWhite  mt4:w-full td4:w-[135px] dmin2:w-[200px] mt-4">
                    {t(props.index < 1 ? "phoneInfo.fields.phoneField" : "phoneInfo.fields.additionalPhoneField")}
                </p>
            )}
            <div className="relative flex justify-between mt-4 dmax2:mt-3 w-full">
                <div className="relative flex flex-col w-full">
                    <div className="relative flex justify-between w-full pl-[1px]">
                        {moreOrEqual650 && (
                            <p className="H16B dmax2:H14B text-textWhite  mt4:w-[75px] td4:w-[135px] dmin2:w-[200px]">
                                {t(
                                    props.index < 1
                                        ? "phoneInfo.fields.phoneField"
                                        : "phoneInfo.fields.additionalPhoneField"
                                )}
                            </p>
                        )}
                        <PhoneInput
                            form={props.form}
                            name={`phones.${props.index}.phone`}
                            meta={props.fields.phones.schema.phone}
                            className="w-[330px] di6:w-[300px] ti7:w-[250px] tmax4:w-full h-[52px] dmax2:h-[45px]"
                        />
                    </div>
                    <CustomError
                        errorKey={_.get((props.form.errors.phones as string[])?.at(props.index), "phone")}
                        className="mt-2 dmax2:mt-1 text-end"
                    />
                </div>
            </div>
            <div className="flex items-end justify-end mt-2">
                <div className="flex items-center mr-8 dmax2:mr-6">
                    <CustomCheckbox
                        labelKey=""
                        checked={props.value.viber}
                        onClick={props.viberCheckboxHandler(props.index)}
                        checkboxClassName="flex justify-center items-center w-6 h-6 border-2 border-textFaded rounded-sm cursor-pointer transition duration-200 mr-4 tmax4:mr-3"
                        checkboxCheckedClassName="!border-0 bg-textWarning"
                        wrapClassName="flex items-center tmax4:items-start"
                        additionalLayoutElement={<CheckMarkIconSVG />}
                    />
                    <img src="images/viber.png" alt="viber" className="w-9 tmax4:w-8 h-9 tmax4:h-8" />
                </div>
                <div className="flex items-center">
                    <CustomCheckbox
                        labelKey=""
                        checked={props.value.whatsapp}
                        onClick={props.whatsappCheckboxHandler(props.index)}
                        checkboxClassName="flex justify-center items-center w-6 h-6 border-2 border-textFaded rounded-sm cursor-pointer transition duration-200 mr-4 tmax4:mr-3"
                        checkboxCheckedClassName="!border-0 bg-textWarning"
                        wrapClassName="flex items-center tmax4:items-start"
                        additionalLayoutElement={<CheckMarkIconSVG />}
                    />
                    <img src="images/whatsapp.png" alt="whatsapp" className="w-9 tmax4:w-8 h-9 tmax4:h-8" />
                </div>
            </div>
        </div>
    );
}

export default MobilePhoneInfo;
